import angular from 'angular';
import appSettingsModule from '../app.settings.module';
import serviceModule from '../services/service.module';
import EquipmentService from './equipment.service';
import UsersService from './users.services';
import UsersMockService from './users.mock.services';
import AlertsMockService from './alerts.mock.service';
import AlertsService from './alerts.service';
import CommandsRepo from './commands.repo';
import ConfigService from './config.service';
import ConfigurationsService from './configurations.service';
import CSVDataExportService from './csvdataexport.service';
import EquipmentMockService from './equipment.mock.service';
import FeatureService from './feature.service';
import GeolocationService from './geolocation.service';
import GeozoneService from './geozones.service';
import InstallationsMockService from './installations.mock.service';
import InstallationsService from './installations.service';
import JobSchedulerMockService from './jobscheduler.mock.service';
import JobSchedulerService from './jobscheduler.service';
import MaintenanceMockService from './maintenance.mock.service';
import MaintenanceService from './maintenance.service';
import MediaService from './media.service';
import RoleService from './roles.service';
import TemplatesService from './templates.service';
import TransfersService from './transfers.service';
import SearchFavouritesRepository from './searchFavourites.repo';
import AccountsRepo from './accounts.repo';
import BulkActivationService from './bulk-activation.service';
import AccessManagementAPI from './access-management.api';
import OperatorsAPI from './operators.api';
import GroupsAPIService from './groups.api';
import ReportingAPIService from './reporting.api';
import TimeSeriesAPIService from './time-series.api';

const apiModule = angular.module('api', [appSettingsModule, serviceModule]);

apiModule
  .factory('equipmentRepository', EquipmentService)
  .service('EquipmentService', EquipmentService)
  .service('usersService', UsersService)
  .service('usersMockService', UsersMockService)
  .service('AlertsMockService', AlertsMockService)
  .service('AlertsService', AlertsService)
  .service('alertsRepository', AlertsService)
  .service('CommandsRepo', CommandsRepo)
  .service('ConfigService', ConfigService)
  .service('configurationsService', ConfigurationsService)
  .service('CSVDataExportService', CSVDataExportService)
  .service('EquipmentMockService', EquipmentMockService)
  .factory('FeatureService', FeatureService)
  .factory('geolocationService', GeolocationService)
  .service('GeozoneService', GeozoneService)
  .service('equipmentGeozoneService', GeozoneService)
  .service('InstallationsMockService', InstallationsMockService)
  .service('installationsService', InstallationsService)
  .service('InstallationsService', InstallationsService)
  .service('JobSchedulerMockService', JobSchedulerMockService)
  .service('JobSchedulerService', JobSchedulerService)
  .service('MaintenanceMockService', MaintenanceMockService)
  .service('MaintenanceService', MaintenanceService)
  .service('MediaService', MediaService)
  .service('RoleService', RoleService)
  .service('TemplatesService', TemplatesService)
  .service('TransfersService', TransfersService)
  .service('searchFavouritesRepo', SearchFavouritesRepository)
  .service('AccountsRepo', AccountsRepo)
  .service('BulkActivationService', BulkActivationService)
  .service('accessManagementAPI', AccessManagementAPI)
  .service('operatorsAPI', OperatorsAPI)
  .service('groupsAPI', GroupsAPIService)
  .service('reportingAPI', ReportingAPIService)
  .service('timeSeriesAPI', TimeSeriesAPIService);

export default apiModule.name;
